import { Link } from 'react-router-dom';
import { useIsGuest } from '../../common';
import ImageLoader from '../ImageLoader';

interface TableListNameProps {
    link: string,
    title: string | React.ReactNode,
    url?: string,
    noimg?: boolean
    children?: React.ReactNode,
}

function TableListName({ link, title, url, noimg, children }: TableListNameProps) {
    const isGuest = useIsGuest();
    return (
        <div className="table-list__name">
            {!noimg &&
                <div className="table-list__name-image empty-image">
                    {url && <ImageLoader url={url} />}
                </div>
            }
            <div className="table-list__name-body">
                <span className="table-list__name-link">
                    {isGuest ?
                        title
                        :
                        <Link to={link}>{title}</Link>
                    }
                </span>
                {children}
            </div>
        </div>
    );
}

export default TableListName;
